// src/pages/ForgotPassword.js
import React, { useState } from "react";
import axios from "axios";
import "./ForgotPassword.css"; // 🆕 Import your CSS here

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false); // 🆕 track if reset was successful

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        "https://bookmatchup.onrender.com/api/auth/forgot-password",
        { email }
      );
      setMessage(res.data.message);
      setSuccess(true); // 🆕 mark success
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.message || "Error sending reset email");
      setSuccess(false);
    }
  };

  return (
    <div className="auth-page">
      <h2>Forgot Password</h2>

      {!success ? (
        <form onSubmit={handleSubmit} className="auth-form">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">Send Reset Link</button>
        </form>
      ) : (
        <div style={{ marginTop: "20px" }}>
          <a href="/login">
            <button className="auth-success-btn">Back to Login</button>
          </a>
        </div>
      )}

      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default ForgotPassword;
